import { toCamelCaseKeys } from '@iichi/helper/object';
import axios from '@/js/lib/helper/axios';
import { updateToken } from './update_token';

export const checkNewEvent = async (): Promise<''> => {
  const res = await axios.get('/api/user/check-new-event');
  return res.data;
};

export const checkNewItem = async (): Promise<''> => {
  const res = await axios.get('/api/user/check-new-item');
  return res.data;
};

type SigninResponse = { requires2Fa: boolean; message: string };
export const signin = async ({ email, password, remember, trustedDeviceId }: { email: string; password: string; remember: boolean; trustedDeviceId?: string }): Promise<SigninResponse> => {
  const token = await updateToken();
  const res = await axios.post('/api/signin', {
    email,
    password,
    remember,
    token,
    trusted_device_id: trustedDeviceId,
  });
  return toCamelCaseKeys(res.data);
};

export const signup = async ({
  email,
  password,
  memberName,
  subscribeNewsletter,
  transactionToken,
  turnstileToken,
}: {
  email: string;
  password: string;
  memberName: string;
  subscribeNewsletter: boolean;
  transactionToken: string;
  turnstileToken: string;
}): Promise<''> => {
  const token = await updateToken();
  const res = await axios.post('/api/signup', {
    email,
    password,
    member_name: memberName,
    newsletter_subscription: subscribeNewsletter ? '1' : '0',
    token,
    transaction_token: transactionToken,
    turnstile_token: turnstileToken,
  });
  return res.data;
};
